(function() {
    angular
        .module("wzModule")
        .controller("WzController", WzController)

    WzController.$inject = [
        "$rootScope",
        "$scope",
        "$state",
        "$stateParams",
        "$uibModal",
        "userMessagingService",
        "prefs",
        "wzService",
        "telemetryService",
        "googleMapsService",
        "messagePreviewService"
    ]

    function WzController(
        $rootScope,
        $scope,
        $state,
        $stateParams,
        $uibModal,
        userMessagingService,
        prefs,
        wzService,
        telemetryService,
        googleMapsService,
        messagePreviewService
    ){
        "use strict"

        $rootScope.title = "Work Zones | WANCO"
        $scope.customers = $rootScope.customers

        $scope.wz_tabs = "configuration-se"

        $scope.loading = true
        $scope.telemetryService = telemetryService

        $scope.showLabels    = prefs.get().wz.showMapLabels
        $scope.mapOpen       = prefs.get().wz.showMap
        $scope.mapLegendOpen = prefs.get().devices.showMapLegend
        $scope.showClusters  = prefs.get().wz.showMapClusters
        $scope.showPath      = prefs.get().wz.showMapSEPath

        $scope.editCustomer = false
        $scope.editTitle    = false

        $scope.wz     = {}
        $scope.wzEdit = {
            title:      undefined,
            customerID: undefined
        }

        $scope.availableDevices = []

        let map = undefined

        const generatePreviews = async () => {

            for (const device of $scope.wzDevices) {
                if (device.meta.isMessageBoard && device.hasOwnProperty("messageMulti")) {
                    $scope.previewController = await messagePreviewService.getController(device, 100)
                    messagePreviewService.generatePreviewFromMulti($scope.previewController, device.messageMulti, "previewContainer-" + device.device_id, true)
                }
            }
        }

        $scope.applyWzData = async (wz) => {

            const existingDeviceCount = $scope.wz && $scope.wz.devices ? $scope.wz.devices.length : 0

            for (const device of wz.devices) {

                // Device Meta + GPS
                $rootScope.processDevice(device)

                // Date/Time in Time Zone
                if (device.last_date && device.last_date.startsWith("20")) {
                    device.last_date = moment(device.last_date).tz(wz.timezone_iana).format("MMM Do @ HH:mm z")
                }

                // QWS Output Message Board Message Render

                if (device.is_qws_output && device.meta.isMessageBoard && device.message_board.hasOwnProperty("message_strings")) {
                    device.message_board.messageRender = {
                        currentPage: 1,
                        pageCount:   device.message_board.message_strings.length
                    }
                }

                if (device.is_qws_output && !device.active) {

                    device.pinColors = {
                        name:      "gray",
                        lightDark: ["#888888", "#626262"]
                    }
                }

                if (device.is_qws_input && device.hasOwnProperty("qws_sensor") && device.qws_sensor.hasOwnProperty("average_speed")) {

                    device.pinColors = {
                        name:      "green",
                        lightDark: ["#00b000", "#008700"]
                    }

                    if (!device.active) {

                        device.pinColors = {
                            name:      "gray",
                            lightDark: ["#888888", "#626262"]
                        }

                    } else if (Math.ceil(wz.posted_speed_limit * 0.454545) >= device.qws_sensor.average_speed) {

                        device.pinColors = {
                            name:      "red",
                            lightDark: ["#c80000", "#870101"]
                        }

                    } else if (Math.ceil(wz.posted_speed_limit * 0.818181) >= device.qws_sensor.average_speed) {

                        device.pinColors = {
                            name:      "yellow",
                            lightDark: ["#ffc808", "#ad8905"]
                        }
                    }
                }
            }

            $scope.wzDevices    = []
            $scope.wzDevicesGPS = []

            if (wz.hasOwnProperty("devices")) {
                $scope.wzDevices = wz.devices
            }

            $scope.wz = wz
            $scope.wzEdit.title      = wz.title
            $scope.wzEdit.customerID = wz.customer.id

            $scope.availableDevices = $scope.wz.available_devices.sort((a, b) => { return a.name > b.name ? 1 : -1 })

            if ($scope.wz.hasOwnProperty("devices")) {

                $scope.wzDevices.sort((a, b) => {
                    if (a.display_position < b.display_position) { return -1 }
                    if (a.display_position > b.display_position) { return 1 }
                    return 0
                })

                // const seGPSDevices = []
                // const outputs      = []
                // const inputs       = []
                // const other        = []

                // $scope.wzDevices.sort((a, b) => {
                //     if (a.name < b.name) { return -1 }
                //     if (a.name > b.name) { return 1 }
                //     return 0
                // })

                // for (const device of $scope.wzDevices) {

                //     if ($scope.wz.type === "QWS") {
                //         if (device.type === "MessageBoard" && device.output === true) {
                //             outputs.push(device)
                //         } else if (device.type === "QWS Sensor") {
                //             inputs.push(device)
                //         } else {
                //             other.push(device)
                //         }
                //     } else {
                //         if (device.gps.isValid) {
                //             seGPSDevices.push(device)
                //         } else {
                //             other.push(device)
                //         }
                //     }
                // }

                // if ($scope.wz.type === "QWS") {
                //     inputs.sort((a, b) => {
                //         if (a.qws.order < b.qws.order) { return -1 }
                //         if (a.qws.order > b.qws.order) { return 1 }
                //         return 0
                //     })
                // }

                // if ($scope.wz.type === "SE") {
                //     seGPSDevices.sort((a, b) => {
                //         if (a.se.position === 0 && b.se.position === 0) { return 0 }
                //         if (a.se.position === 0) { return 1 }
                //         if (b.se.position === 0) { return -1 }
                //         if (a.se.position < b.se.position) { return -1 }
                //         if (a.se.position > b.se.position) { return 1 }
                //         return 0
                //     })
                // }

                // $scope.wzDevices    = seGPSDevices.concat(outputs).concat(inputs).concat(other)
                $scope.wzDevicesGPS = $scope.wzDevices.filter((device) => { return device.gps.isValid })

                if ($scope.wz.type === "SE") {
                    $scope.wzDevicesGPSPositioned = $scope.wzDevicesGPS.filter((device) => { return device.display_position > 0 })
                }

                let gpsIndex = 0
                let hasGPS   = false

                for (const device of $scope.wzDevices) {
                    if (device.gps.isValid) {
                        gpsIndex++
                        device.gps.index = gpsIndex
                        hasGPS = true
                        // if ($scope.wz.type === "QWS" && device.type === "QWS Sensor") {
                        //     device.gps.subIndex = device.qws.order
                        // }
                    }
                }

                $scope.mapOpen = prefs.get().wz.showMap && hasGPS

            }

            const deviceCountChanged = $scope.wz.devices.length !== existingDeviceCount

            $scope.handleMap(deviceCountChanged)

            await generatePreviews()

            $scope.loading = false

        }

        $scope.toggleEditTitle = () => {
            $scope.editTitle = !$scope.editTitle
        }

        $scope.toggleWzEnabled = () => {

            const originalEnabled = $scope.wz.enabled
            $scope.wz.enabled = !$scope.wz.enabled

            const success = (data) => {
                $scope.applyWzData(data)
            }

            const failure = (error) => {
                console.error(error)
                $scope.wz.enabled = originalEnabled
            }

            wzService.toggleEnabled($stateParams.wz_id, !originalEnabled, success, failure)

        }

        $scope.cancelChangeTitle = () => {
            $scope.editTitle    = false
            $scope.wzEdit.title = $scope.wz.title
        }

        $scope.changeTitle = () => {

            if ($scope.wz.title.trim() === $scope.wzEdit.title.trim()) {
                $scope.editTitle = false
                return
            }

            const success = (data) => {
                $scope.wzEdit.title = data.title
                $scope.wz.title     = data.title
            }

            const failure = (error) => {
                console.error(error)
            }

            wzService.changeTitle($stateParams.wz_id, $scope.wzEdit.title.trim(), success, failure)

            $scope.editTitle = false

        }

        $scope.cancelChangeCustomer = () => {
            $scope.editCustomer      = false
            $scope.wzEdit.customerID = $scope.wz.customer.id
        }

        $scope.changeCustomer = () => {

            if ($scope.wz.customer.id === $scope.wzEdit.customerID) {
                $scope.editCustomer = false
                return
            }

            const performCustomerChange = () => {

                const success = (data) => {
                    $scope.wzEdit.customerID = data.customer.id
                    $scope.wz.customer.id    = data.customer.id
                    $scope.wz.customer.name  = data.customer.name
                }

                const failure = (error) => {
                    console.error(error)
                }

                wzService.changeCustomer($stateParams.wz_id, $scope.wzEdit.customerID, success, failure)

                $scope.editCustomer = false

            }

            if ($scope.wzDevices.length > 0) {

                $uibModal.open({
                    templateUrl: "app/modals/wz-change-customer-modal.view.html",
                    controller: "WzChangeCustomerModalController",
                    resolve: {
                        performChange: () => {
                            return performCustomerChange
                        }
                    }
                }).result.catch(function(res) {
                    if (!(res === "cancel" || res === "escape key press")) {
                        throw res
                    }
                })

            } else {

                performCustomerChange()

            }
        }

        $scope.delete = () => {

            $uibModal.open({
                templateUrl: "app/modals/wz-delete-modal.view.html",
                controller: "WzDeleteModalController",
                resolve: {
                    wzTitle: () => {
                        return $scope.wz.title
                    },
                    wzID: () => {
                        return $scope.wz.id
                    },
                    success: () => {
                        return () => {
                            $state.go("devices").then(() => {
                                userMessagingService.success("Work Zone Successfully Deleted")
                            })
                        }
                    },
                    failure: () => {
                        return (error) => {
                            userMessagingService.error("Failed to Delete Work Zone: " + error)
                        }
                    }
                }
            }).result.catch((res) => {
                if (!(res === "cancel" || res === "escape key press")) {
                    throw res
                }
            })
        }

        $scope.removeDeviceFromWZ = (deviceID) => {

            const success = (data) => {
                if (data) {
                    $scope.applyWzData(data)
                }
            }

            const failure = (error) => {
                console.error(error)
            }

            wzService.removeDevice($stateParams.wz_id, deviceID, success, failure)

        }

        //
        // HANDLE MAP RENDER
        //

        $scope.handleMap = function(forceNewMap) {

            const showPath = $scope.showPath && ($scope.wz.hasOwnProperty("type") && $scope.wz.type === "SE")
            const showHeat = $scope.wz.hasOwnProperty("type") && $scope.wz.type === "QWS"

            if (map === undefined || forceNewMap) {
                googleMapsService.createMap("mapConstruct").then((mapObject) => {
                    map = mapObject
                    googleMapsService.setMarkers(true, map, $scope.wzDevicesGPS, $scope.showLabels, $scope.showClusters, showPath, showHeat)
                })

            } else {
                googleMapsService.setMarkers(false, map, $scope.wzDevicesGPS, $scope.showLabels, $scope.showClusters, showPath, showHeat)
            }
        }

        const mapHeightWhileLegendOpen   = Number($("#mapContainer").css("height").match(/\d+/g))
        const mapLegendHeight            = Number($("#mapLegendSection").css("height").match(/\d+/g))
        const mapHeightWhileLegendClosed = mapHeightWhileLegendOpen - mapLegendHeight

        let mapChangeProceedOpen  = true
        let mapChangeProceedClose = true
        let mapLegendChangeProceedOpen  = true
        let mapLegendChangeProceedClose = true

        if (!$scope.mapOpen) {

            $("#mapContainer").css("height", "0px")
            $("#mapContainer").css("visibility", "hidden")
            $("#mapOptions").css("opacity", 0)
            $("#mapOptions").css("visibility", "hidden")

        } else if (!$scope.mapLegendOpen) {

            $("#mapContainer").css("height", String(mapHeightWhileLegendClosed) + "px")

        }

        $scope.toggleLegend = function() {

            const duration = 125
            const factor = 15

            const mapContainer = $("#mapContainer")

            const close = () => {
                if (mapLegendChangeProceedClose) {

                    let height = Number(mapContainer.css("height").match(/\d+/g))
                    let newHeight = height - Math.ceil((height - mapHeightWhileLegendClosed) / factor)

                    if (newHeight > mapHeightWhileLegendClosed) {

                        mapContainer.css("height", String(newHeight) + "px")

                        setTimeout(() => {
                            close()
                        }, (duration / factor))

                    } else {

                        mapContainer.css("height", String(mapHeightWhileLegendClosed) + "px")

                        prefs.set(prefs.selectors().devices.showMapLegend, $scope.mapLegendOpen)

                    }
                }
            }

            const open = () => {

                if (mapLegendChangeProceedOpen) {

                    let height = Number(mapContainer.css("height").match(/\d+/g))
                    let newHeight = height + Math.ceil((mapHeightWhileLegendOpen - height) / factor)

                    if (newHeight < mapHeightWhileLegendOpen) {

                        mapContainer.css("height", String(newHeight) + "px")

                        setTimeout(() => {
                            open()
                        }, (duration / factor))

                    } else {

                        mapContainer.css("height", String(mapHeightWhileLegendOpen) + "px")

                        prefs.set(prefs.selectors().devices.showMapLegend, $scope.mapLegendOpen)

                    }
                }
            }

            if ($scope.mapLegendOpen) {

                mapLegendChangeProceedClose = true
                mapLegendChangeProceedOpen  = false
                $scope.mapLegendOpen = false
                close()

            } else {

                mapLegendChangeProceedClose = false
                mapLegendChangeProceedOpen  = true
                $scope.mapLegendOpen = true
                open()

            }
        }

        $scope.toggleLabels = function() {

            $scope.showLabels = !$scope.showLabels
            googleMapsService.toggleMarkerLabels()
            prefs.set(prefs.selectors().wz.showMapLabels, $scope.showLabels)

        }

        $scope.toggleClusters = function() {

            $scope.showClusters = !$scope.showClusters
            prefs.set(prefs.selectors().wz.showMapClusters, $scope.showClusters)
            $scope.handleMap()

        }

        $scope.togglePath = function() {

            $scope.showPath  = !$scope.showPath
            prefs.set(prefs.selectors().wz.showMapSEPath, $scope.showPath)
            $scope.handleMap()

        }

        $scope.toggleMap = function() {

            const duration = 125
            const factor = 15

            const mapContainer = $("#mapContainer")
            const mapOptions   = $("#mapOptions")

            const close = () => {

                if (mapChangeProceedClose) {

                    let height = Number(mapContainer.css("height").match(/\d+/g))
                    let newHeight = height - Math.ceil(height / factor)
                    let newOpacity = Number(mapOptions.css("opacity")) - (0.8 / factor)

                    if (newHeight > 0) {

                        mapContainer.css("height", String(newHeight) + "px")
                        mapOptions.css("opacity", newOpacity)
                        setTimeout(() => {
                            close()
                        }, (duration / factor))

                    } else {

                        mapContainer.css("height", "0px")
                        mapContainer.css("visibility", "hidden")
                        mapOptions.css("opacity", 0)
                        mapOptions.css("visibility", "hidden")

                        prefs.set(prefs.selectors().wz.showMap, $scope.mapOpen)

                    }
                }
            }

            const open = () => {

                if (mapChangeProceedOpen) {

                    const mapHeightBase = $scope.mapLegendOpen ? mapHeightWhileLegendOpen : mapHeightWhileLegendClosed

                    mapContainer.css("visibility", "visible")
                    mapOptions.css("visibility", "visible")

                    let height = Number(mapContainer.css("height").match(/\d+/g))
                    let newHeight = height + Math.ceil((mapHeightBase - height) / factor)
                    let newOpacity = Number(mapOptions.css("opacity")) + (1 / factor)

                    if (newHeight < mapHeightBase) {

                        mapContainer.css("height", String(newHeight) + "px")
                        mapOptions.css("opacity", newOpacity)

                        setTimeout(() => {
                            open()
                        }, (duration / factor))

                    } else {

                        mapContainer.css("height", String(mapHeightBase) + "px")
                        mapOptions.css("opacity", 1)

                        prefs.set(prefs.selectors().wz.showMap, $scope.mapOpen)

                    }
                }
            }

            if ($scope.mapOpen) {

                mapChangeProceedOpen  = false
                mapChangeProceedClose = true
                $scope.mapOpen = false
                close()

            } else {

                mapChangeProceedClose = false
                mapChangeProceedOpen  = true
                $scope.mapOpen = true
                $scope.handleMap()
                open()

            }
        }

        //
        // EVENTS
        //

        $scope.$on('$destroy', () => {
            if ($scope.previewController) {
                $scope.previewController.dispose()
            }
        })

        $scope.$watch("$root.pushedWzData", (pushedWzData) => {

            if (pushedWzData.hasOwnProperty("wz") && pushedWzData.wz.hasOwnProperty("id")) {

                if (pushedWzData.wz.id === $scope.wz.id) {
                    $scope.applyWzData(pushedWzData.wz)
                }
            }
        })

        $scope.$watch("$root.customers", () => {
            $scope.customers = $rootScope.customers
        })

        const getWz = () => {

            const success = (data) => {
                if (data && data.type) {
                    if (data.type === "QWS") {
                        $state.go("wz.configuration-qws", { wz_id: data.id })
                    } else {
                        $state.go("wz.configuration-se", { wz_id: data.id })
                    }
                }
                $scope.applyWzData(data)
            }

            const failure = (error) => {
                console.error(error)
            }

            wzService.show($stateParams.wz_id, success, failure)

        }

        getWz()

    }
})()
